const pageOverlay = document.querySelector(".pageOverlay");
const menuPageOverlay = document.querySelector(".menuPageOverlay");
const mobileMenuTrigger = document.querySelector(".toggleMenu");
const mobileMenuCloseTrigger = document.querySelector(
  ".mobilemenu__close-trigger"
);
const mobileSearchTrigger = document.querySelector(".mobile-search__trigger");
const advancedFilterAllCollectionButton = document.querySelector(
  ".directory_label_0 a[title=All]"
);
const popupAdvancedFilterAllCollectionButton = document.querySelector(
  ".advanced-filter__popup-section .directory_label_0 a[title=All]"
);
const selectVehiclePopupTriggers = document.querySelectorAll(
  ".select-vehicle__popup-trigger"
);
const advancedFilterPopupSection = document.querySelector(
  ".advanced-filter__popup-section"
);
const megamenuTriggerButtons = document.querySelectorAll(
  ".megamenu__trigger-button"
);
const collapsibleTabTitles = document.querySelectorAll(
  ".collapsible-tab__title-wrapper"
);
const collapsibleTabData = document.querySelectorAll(".collapsible-tab__data");
const cartDrawerShoppingButton = document.querySelector(
  ".continue-shopping__button-wrapper .continue-shopping__button"
);
const footerSocialMenuItemTrigger = document.querySelector(".social-menu__trigger");

const openMobileMenu = () => {
  menuPageOverlay.classList.add("pageOverlay__visible");
  document.body.classList.add("mobile-menu__open");
};

const closeMobileMenu = () => {
  menuPageOverlay.classList.remove("pageOverlay__visible");
  document.body.classList.remove(
    "mobile-menu__open",
    "modal-active",
    "no-scroll"
  );
};

mobileMenuTrigger &&
  mobileMenuTrigger.addEventListener("click", openMobileMenu);
menuPageOverlay && menuPageOverlay.addEventListener("click", closeMobileMenu);
mobileMenuCloseTrigger &&
  mobileMenuCloseTrigger.addEventListener("click", closeMobileMenu);

mobileSearchTrigger &&
  mobileSearchTrigger.addEventListener("click", () => {
    document.body.classList.toggle("mobile-search__open");
  });

// document.addEventListener("readystatechange", () => {
//   if (document.readyState == "complete") {
//     advancedFilterAllCollectionButton &&
//       advancedFilterAllCollectionButton.click();
//   }
// });

megamenuTriggerButtons &&
  megamenuTriggerButtons.forEach((megamenuTriggerButton) => {
    megamenuTriggerButton.addEventListener("click", (e) => {
      e.currentTarget.parentElement.parentElement.classList.toggle(
        "mega-dropdown__open"
      );
    });
  });

collapsibleTabTitles &&
  collapsibleTabTitles.forEach((collapsibleTabTitle) => {
    let collapsibleTabHeight =
      collapsibleTabTitle.nextElementSibling.offsetHeight;
    collapsibleTabTitle.nextElementSibling.style.height = "0";
    collapsibleTabTitle.addEventListener("click", (e) => {
      e.currentTarget.parentElement.classList.toggle("collapsible-tab__open");
      e.currentTarget.nextElementSibling.style.height = `${collapsibleTabHeight}px`;
      if (
        !e.currentTarget.parentElement.classList.contains(
          "collapsible-tab__open"
        )
      ) {
        e.currentTarget.nextElementSibling.style.height = "0";
      }
    });
  });

selectVehiclePopupTriggers &&
  selectVehiclePopupTriggers.forEach((selectVehiclePopupTrigger) => {
    selectVehiclePopupTrigger.addEventListener("click", () => {
      popupAdvancedFilterAllCollectionButton &&
        popupAdvancedFilterAllCollectionButton.click();
      pageOverlay.classList.add("pageOverlay__visible");
      advancedFilterPopupSection.classList.add(
        "advanced-filter__popup-section-visible"
      );
      document.body.classList.add("no-scroll");
    });
  });

pageOverlay.addEventListener("click", () => {
  pageOverlay.classList.remove("pageOverlay__visible");
  if (
    advancedFilterPopupSection.classList.contains(
      "advanced-filter__popup-section-visible"
    )
  ) {
    advancedFilterPopupSection.classList.remove(
      "advanced-filter__popup-section-visible"
    );
  }

  if (document.body.classList.contains("no-scroll")) {
    document.body.classList.remove("no-scroll");
  }
});

cartDrawerShoppingButton &&
  cartDrawerShoppingButton.addEventListener("click", (e) => {
    e.preventDefault();
    document.getElementById("cart-count-desktop").classList.remove("hover");
    document.getElementById("cart-count-desktop").classList.add("avoid");
    setTimeout(() => {
      document.getElementById("cart-count-desktop").classList.remove("avoid");
    }, 100);
  });

  footerSocialMenuItemTrigger && footerSocialMenuItemTrigger.addEventListener("click", () => {
    footerSocialMenuItemTrigger.nextElementSibling.classList.toggle("footer-social__dropdown-visible");
  })

const header = document.querySelector('.header.header-customerbar');
const headerHeight = header.offsetHeight;
window.addEventListener('scroll', function() {
  const advanceHomepage = document.querySelector('.advance_filter_homepage')
  if(advanceHomepage){
    if (window.innerWidth <= 768) {
        if (window.scrollY < 500) {
            advanceHomepage.classList.remove('advance-filter--fixed');
            advanceHomepage.style.top = 0;
        } else {
            advanceHomepage.classList.add('advance-filter--fixed');
            advanceHomepage.style.top = headerHeight+"px"; 
        }
    } else {
        if (window.scrollY < 550) {
            advanceHomepage.classList.remove('advance-filter--fixed');
          advanceHomepage.style.top = 0;
        } else {
            advanceHomepage.classList.add('advance-filter--fixed');
            advanceHomepage.style.top = headerHeight+"px"; 
        }
    }
  }
});

const element = document.getElementById('shopify-section-header');
function addClassOnScroll() {
    if (window.scrollY > 10) {
        element.classList.add('sticky_header');
    } else {
        element.classList.remove('sticky_header');
    }
}
window.addEventListener('scroll', addClassOnScroll);